module.exports = __webpack_public_path__ + "static/media/mirai.6eeb1f71.png";